'use client';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { WISHLIST_QUERIES } from '../../infrastructure/wishlist/utils/queries';
import type { GetWishlistRequest } from '../../infrastructure/wishlist/utils/types';

interface UseGetWishlistOptions {
  enabled?: boolean;
}

export const useWishlistService = () => {
  const useGetWishlist = (payload: GetWishlistRequest, { enabled = true }: UseGetWishlistOptions = {}) =>
    useQuery({
      ...WISHLIST_QUERIES.getWishlist(payload),
      // A read must never run without an owner: the API mints a throwaway guest wishlist for keyless reads.
      enabled: enabled && Boolean(payload.customerKey),
    });

  const useAddProductToWishlist = () => {
    const queryClient = useQueryClient();
    return useMutation(WISHLIST_QUERIES.addProductToWishlist(queryClient));
  };

  const useRemoveProductFromWishlist = () => {
    const queryClient = useQueryClient();
    return useMutation(WISHLIST_QUERIES.removeProductFromWishlist(queryClient));
  };

  const useMigrateWishlist = () => {
    const queryClient = useQueryClient();
    return useMutation(WISHLIST_QUERIES.migrateWishlist(queryClient));
  };

  return {
    useAddProductToWishlist,
    useRemoveProductFromWishlist,
    useMigrateWishlist,
    useGetWishlist,
  };
};
